/* ==========================================================================
   Image > Client > Prototype
   ========================================================================== */

/* Modules */
require('lazysizes');
const { timer } = require('rxjs');
const { take, repeat } = require('rxjs/operators');
const ViewHelpers = require('@bluekiri/alexandria/core/ViewHelpers');

let TRIGGERED = false;

/* Prototype */
const prototype = {
    /* Create loop */
    createLoop() {
        /* Exit if we have no images to loop */
        if (!this.config.images) return new Error("It seems that you don't have images to loop from");

        return timer(this.config.delay, this.config.delay).pipe(
            take(this.config.images.length),
            repeat(this.config.loops === 0 ? false : this.config.loops)
        );
    },
    /* Start loop */
    startLoop() {
        /* Exit if we have no images to loop */
        if (!this.config.images) return new Error("It seems that you don't have images to loop from");

        this.loop = this.createLoop().subscribe({
            next: index => this.setImage(this.config.images[index].src, this.config.resize).init(),
            error: () => {},
            complete: () => {}
        });

        return this;
    },
    /* Stop loop */
    stopLoop() {
        /* Exit if we have no images to loop */
        if (!this.config.images) return new Error("It seems that you don't have images to loop from");

        this.loop.unsubscribe();

        return this;
    },
    /* Get alt */
    getAlt() {
        return this.getImageEl().alt;
    },
    /* Get title */
    getTitle() {
        return this.getImageEl().title;
    },
    /* Get Image element */
    getImageEl: function getImageEl() {
        return this.element.querySelector('img');
    },
    /* Set Image */
    setImage: function setImage(src, options = false) {
        let opts = false;

        if (options) {
            opts = {
                operation: options.operation || this.config.resize.operation,
                suboperation: options.suboperation || this.config.resize.suboperation,
                width: options.width || this.config.resize.width,
                height: options.height || this.config.resize.height,
                quality: options.quality || this.config.resize.quality
            };
        }

        this.getImageEl().dataset.src = ViewHelpers(this.config.context).renderImage(src, opts);

        return this;
    },
    /* Start lazy */
    startLazy: function startLazy() {
        this.getImageEl().classList.remove('lazyloaded');
        this.getImageEl().classList.add('lazyload');
    },
    /* Binding events */
    bindEvents: function bindEvents() {
        this.onError = this.onError.bind(this);

        return this;
    },
    /* onError */
    onError: function onError() {
        this.getImageEl().src = this.getImageEl().dataset.alternative;

        return this;
    },
    /* Add event listener */
    addEventListener: function addEventListener() {
        /* Bind events */
        this.bindEvents();

        /* Error */
        this.getImageEl().addEventListener('error', this.onError, { once: true });

        /* Lazy loaded */
        if (!TRIGGERED)
            this.getImageEl().addEventListener(
                'lazyloaded',
                () => {
                    if (this.config.autoplay) this.startLoop();
                    TRIGGERED = true;
                },
                { once: true }
            );
    },
    /* Init */
    init: function init() {
        /* Exit in case its not lazy */
        if (this.config.disableLazy) return this;

        /* Add event listener */
        this.addEventListener();

        /* Start lazy load */
        this.startLazy();

        /* Return */
        return this;
    }
};

module.exports = prototype;
